import styled from 'styled-components'

export const ReelsContainer = styled.div``
export const ReelsSwiperWrap = styled.div`
  position: relative;
`
